/* eslint-disable no-console */
import rtm from '@pearsontechnology/aero-rtm';
import { dispatch } from 'pluginServices/store';
import { showOverlay, hideOverlay } from 'containers/ToastManager/actions';
import appConfig from 'appConfig';

class ConnectionManager {
  constructor() {
    this.isConnected = false;
    this.reconnectHandler = this._reconnect.bind(this);
  }

  /**
   * * Monitors WS connection activity
   */
  _monitorConnection() {
    // setting up listeners for onclose and onOpen events
    // show connect/disconnect overlay
    this.connection.onClose((payload) => {
      if (!payload.disableReconnect) {
        dispatch(showOverlay());
      }
    });
    this.connection.onOpen(() => {
      dispatch(hideOverlay());
    });
    // monitor browser connectivity
    window.addEventListener('offline', this.reconnectHandler, true);
  }

  _reconnect() {
    if (this.isConnected) {
      this.connection.reconnect();
    }
  }

  async openConnection(credentials) {
    this.connection = await rtm.open(appConfig.getAuthorWebsocketURL(), credentials);
    this.isConnected = true;
    this._monitorConnection();
    return this.connection;
  }

  getConnection() {
    return this.connection;
  }

  closeConnection() {
    window.removeEventListener('offline', this.reconnectHandler, true);
    this.connection.shutDown();
    this.connection = undefined;
    this.isConnected = false;
  }
}

export default ConnectionManager;
